// extracted by mini-css-extract-plugin
export var button = "_pf-0";